exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ellipsis[data-v-a71ce146]{position:relative}.ellipsis span[data-v-a71ce146]{float:left;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a71ce146","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/survey/summary/TextSummary.vue
// module id = b4Jc
// module chunks = 1